// Reglas de completitud del perfil (Información personal + Depósito).
// Única fuente de verdad: las usan la validación de /profile y el banner
// global de "completá tus datos". Si se agrega un campo obligatorio, se
// agrega acá y ambos lados quedan en sync.

const isBlank = (v) => !v || !String(v).trim();

// La empresa cuenta como "sin completar" si está vacía, si quedó el
// placeholder histórico "VORAS" (hardcode del registro viejo) o si es el
// autogenerado "Nombre Apellido" del backend (dual-write): en ambos casos el
// usuario nunca escribió el nombre real de su negocio.
export const isCompanyPlaceholder = (company, firstname, lastname) => {
  if (isBlank(company)) return true;
  const c = String(company).trim().toLowerCase();
  if (c === "voras") return true;
  const auto = `${firstname || ""} ${lastname || ""}`.trim().toLowerCase();
  return auto !== "" && c === auto;
};

// Nombre de empresa PARA MOSTRAR: si es el placeholder/autogenerado, se
// devuelve vacío. Así el campo Empresa se ve vacío cuando en realidad nadie
// lo cargó — el banner dice "falta Empresa" y el campo vacío lo confirma
// (mostrar el autogenerado con el banner reclamando parecía un bug).
export const displayCompanyName = (company, firstname, lastname) =>
  isCompanyPlaceholder(company, firstname, lastname) ? "" : String(company).trim();

// user: { firstname, lastname, company } — devuelve labels de lo que falta.
export const getMissingUserFields = (user) => {
  const missing = [];
  if (isBlank(user?.firstname)) missing.push("Nombre");
  if (isBlank(user?.lastname)) missing.push("Apellido");
  if (isCompanyPlaceholder(user?.company, user?.firstname, user?.lastname)) missing.push("Empresa");
  return missing;
};

export const DEPOSITO_REQUIRED_FIELDS = [
  ["name", "Nombre del depósito"],
  ["street", "Calle"],
  ["number", "Número"],
  ["reference", "Referencia"],
  ["postal_code", "Código postal"],
  ["province", "Provincia"],
  ["department", "Localidad"],
  ["phone", "Teléfono"],
];

// deposito: fila de warehouse (o null si no existe) — labels de lo que falta.
export const getMissingDepositoFields = (deposito) => {
  if (!deposito) return DEPOSITO_REQUIRED_FIELDS.map(([, label]) => label);
  return DEPOSITO_REQUIRED_FIELDS.filter(([key]) => isBlank(deposito[key])).map(
    ([, label]) => label
  );
};

// Evento global que dispara el perfil al guardar, para que el banner se
// re-evalúe sin recargar. (window event: el banner vive en otra rama del árbol.)
export const PROFILE_UPDATED_EVENT = "voras:profile-updated";
